/**
 * Canonical list of Marketplace admin emails.
 * Used by both AiMarketplacePage (Analytics button visibility)
 * and DashboardPage (access guard).
 *
 * To add or remove an admin, update this single file.
 */
export const MARKETPLACE_ADMIN_EMAILS: ReadonlySet<string> = new Set([
  'itay.koren@verint.com',
  'asaf.stier@verint.com',
  'jamie.williams@verint.com',
  'rob.scudiere@verint.com',
  'henry.zektser@verint.com',
  'darshan.a@verint.com',
  'aviral.gupta@verint.com',
  'sanu.kumar@verint.com',
]);
